import CrossBorderToggle from '@ui/CrossBorderToggle/component'

export default function (): void {
  const crossBorderEl = document.querySelector<HTMLElement>('.cross-border-toggle .o-chip-toggle')
  crossBorderEl && CrossBorderToggle(crossBorderEl)
}
